import { useMutation } from '@tanstack/react-query';
import { addContactPhoneDetails } from '../../services/fn-api/User';

export const useAddContactPhoneDetails = () => {
  return useMutation<Record<string, unknown>, Error, Record<string, unknown>>({
    mutationFn: async (data) => {
      return addContactPhoneDetails(data);
    },
  });
};
